// src/features/counterSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import {
  LpHeroSectionType,
  LpExploreSectionType,
  LpStartProcessType,
  LpMapAreaType,
  LpFooterType,
  LpNavigationType,
  LpSeoType,
  LpSettings,
  LpFeatureProductsType,
  LpFlyPageItem,
} from '../../Types/landing-page';

export interface LandingPageState {
  token?: string;
  navigation?: LpNavigationType;
  heroSection?: LpHeroSectionType;
  explorSection?: LpExploreSectionType;
  startProcess?: LpStartProcessType;
  featuredProducts?: LpFeatureProductsType;
  mapArea?: LpMapAreaType;
  footer?: LpFooterType;
  seo?: LpSeoType;
  setting?: LpSettings;
  videoPreviewDone?: boolean;
  popup_video_url: string;
  popup_visibility: string;
  certifications: string[];
  flyPages: LpFlyPageItem[];
}

const initialState: LandingPageState = {
  certifications: [],
  popup_video_url: '',
  popup_visibility: 'false',
  flyPages: [],
};

const landingPageSlice = createSlice({
  name: 'landingPage',
  initialState,
  reducers: {
    setToken: (state, action: { payload: string }) => {
      state.token = action.payload;
    },
    setLandingPageState: (state, action: { payload: LandingPageState }) => {
      state.navigation = action.payload.navigation;
      state.heroSection = action.payload.heroSection;
      state.explorSection = action.payload.explorSection;
      state.startProcess = action.payload.startProcess;
      state.featuredProducts = action.payload.featuredProducts;
      state.mapArea = action.payload.mapArea;
      state.footer = action.payload.footer;
      state.seo = action.payload.seo;
      state.setting = action.payload.setting;
      state.certifications = action.payload.certifications;
      state.popup_video_url = action.payload.popup_video_url;
      state.popup_visibility = action.payload.popup_visibility;
      state.flyPages = action.payload.flyPages || [];
    },
    setVideoPreviewDone: (state, action: { payload: boolean }) => {
      state.videoPreviewDone = action.payload;
    },
  },
});

export const { setLandingPageState, setToken, setVideoPreviewDone } =
  landingPageSlice.actions;
export default landingPageSlice.reducer;
